import { callFunction } from './firebase/FunctionsService';

/**
 * Requests a branded password-reset email (Resend + `/auth/action`).
 * Passes the raw username so the server always runs Firestore login resolution
 * (never a client-side `@AUTH_EMAIL_DOMAIN` append that would skip lookup).
 */
export async function sendPasswordResetForUsername(username: string): Promise<void> {
  await callFunction('requestPasswordReset', { username: String(username ?? '').trim() });
}
